<template>
  <div id="payment-element">
    <h2>Make Payment</h2>
    <div class="block tabular" style="padding: 20px; position: relative;">
      <p>
        Add credit to your account. Enter the amount below then continue to
        securely enter your details
      </p>

      <PaymentChoice
        ref="paymentChoice"
        gtag-reference="PrePay"
        :debt-percent="debtPercent"
        allow-full-debt
        multi-pay
        @handleRequest="requestPayment"
        @complete="resetPayment"
      ></PaymentChoice>
    </div>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { faSpinner, faAlignLeft } from "@fortawesome/free-solid-svg-icons";
import PaymentChoice from "@/views/Components/Payment/PaymentChoice.vue";

library.add(fas, faSpinner, faAlignLeft);

export default {
  name: "MakePayment",
  components: { PaymentChoice },
  props: {
    id: {
      type: String,
      required: true
    },
    debtPercent: {
      type: String
    }
  },
  data() {
    return {
      paymentLoading: false,
      paymentComplete: false
    };
  },
  methods: {
    resetPayment() {
      this.paymentComplete = false;
    },
    requestPayment({ amount, isFullDebt, paymentType }) {
      this.$store
        .dispatch("requestPayment", {
          amount: amount,
          id: this.id,
          isFullDebt: isFullDebt,
          paymentType: paymentType
        })
        .then(response => {
          this.$gtag.event("payment", {
            event_category: "paymentRequestedPrePay",
            event_label: amount
          });

          this.$refs.paymentChoice.loadPayment(response.data.ref);
        })
        .catch(err => {
          const title = "Payment Error";
          const subtitle = err;
          const samePage = true;
          this.$store.dispatch("pushError", { title, subtitle, samePage });
          this.$refs.paymentChoice.setPaymentError();
        })
        .finally(() => {
          this.paymentLoading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/scss/dashboard";
</style>
